import { reactive, ref, computed } from '@vue/composition-api'

/**
 * ダッシュボードのウィジェットの並び替えウィンドウ
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    /**
     * 対象ウィジェットを最上位に移動
     */
    moveWidgetToTop: () => {
      context.emit('moveWidgetToTop')
    },

    /**
     * 対象ウィジェットを一つ上に移動
     */
    moveWidgetUpOne: () => {
      context.emit('moveWidgetUpOne')
    },

    /**
     * 対象ウィジェットを一つ下に移動
     */
    moveWidgetDownOne: () => {
      context.emit('moveWidgetDownOne')
    },

    /**
     * 対象ウィジェットを最下位に移動
     */
    moveWidgetToBottom: () => {
      context.emit('moveWidgetToBottom')
    }
    
  })

  return group1
}
